import React, { useState } from 'react';
import { Star, MessageSquare, Search, CheckCircle, Mail, FolderKanban } from 'lucide-react';
import { Button } from './ui/Button';
export const InfluencerHub = () => <section className="py-16 bg-white border-t border-gray-100" data-id="element-428" data-mp="295mfgrspg6oi">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-429" data-mp="2941jqyunmhp2">
      <div className="inline-flex items-center justify-center mb-6" data-id="element-430" data-mp="25416vin7eek4">
        <img src="https://cdn.magicpatterns.com/uploads/2roKm1Fk7NMWKUUjaFCrht/im_(2).png" alt="Top Influencer Marketplaces 2026 Badge" className="h-32 w-auto" data-id="element-431" data-mp="205pxf90tm62f" />
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-432" data-mp="1q8bff4z91980">
        Ranked #7 Best Influencer Marketing Marketplace
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-433" data-mp="1m7rncftj8vsq">
        Recognized by{' '}
        <a href="https://influencermarketinghub.com/influencer-marketplaces/" target="_blank" rel="noopener noreferrer" className="text-zano-pink hover:underline font-medium" data-id="element-434" data-mp="3kki3h4d8rkhq">
          Influencer Marketing Hub
        </a>{' '}
        for our unique approach to capture represented talent at scale —
        something no one else is doing.
      </p>
      <p className="text-sm text-gray-500 max-w-xl mx-auto" data-id="element-435" data-mp="1wn0ccobnu6wj">
        Zano was placed #7 because of our unique position in the market:
        providing direct access to the elite layer of talent representation and
        connecting brands with 400+ agencies managing 6,000+ creators.
      </p>
    </div>
  </section>;
export const CapterraReviews = () => <section className="py-16 bg-gray-50 border-t border-gray-100" data-id="element-436" data-mp="2fkuv3u2lbws4">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-437" data-mp="2fi8l7ns8956q">
      <div className="flex justify-center mb-6" data-id="element-438" data-mp="2jjtyha8oblhg">
        <a href="https://www.capterra.com/p/10027632/Zano/reviews/" target="_blank" rel="noopener noreferrer" data-id="element-439" data-mp="37apj9neppgf7">
          <img src="https://brand-assets.capterra.com/badge/fa921502-adb9-4b73-b611-d6c5e380b1b0.svg" alt="Zano reviews on Capterra" className="h-20 w-auto" data-id="element-440" data-mp="3c38yspwymlmn" />
        </a>
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-441" data-mp="3cx9kc4lr05jk">
        5-Star Rated on Capterra
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-442" data-mp="37yoki6aernvn">
        Users love Zano for its ease of use and exceptional UX design.
        Navigating the platform and finding the right talent has never been
        simpler.
      </p>
    </div>
  </section>;
export const Newsletter = () => {
  const [submitted, setSubmitted] = useState(false);
  return <section className="py-20 bg-zano-charcoal text-white" data-id="element-443" data-mp="2u70b4arjndid">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-444" data-mp="2p8gnm5xaxtnw">
        <Mail className="mx-auto text-zano-pink mb-6" size={32} data-id="element-445" data-mp="2k8b3datd39fu" />
        <h2 className="text-3xl font-bold mb-4" data-id="element-446" data-mp="2k7t0vwg3vyzh">Subscribe to our Newsletter</h2>
        <p className="text-gray-300 mb-8" data-id="element-447" data-mp="2fa16mvrzo0s4">
          Get industry insights from the agency perspective, discover top
          agencies and represented influencers on Zano, and stay updated on
          platform features and casting calls.
        </p>
        {submitted ? <div className="flex items-center justify-center gap-2 text-white font-medium" data-id="element-448" data-mp="2f3gy0j4bsuh5">
            <CheckCircle className="text-green-400" size={20} data-id="element-449" data-mp="2k33ed1fgaqu6" /> Thanks — you're
            subscribed.
          </div> : <form onSubmit={e => {
        e.preventDefault();
        setSubmitted(true);
      }} className="flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto" data-id="element-450" data-mp="1mgmkk65xevd6">
            <input type="email" placeholder="Enter your email" className="px-4 py-3 rounded-lg text-gray-900 w-full outline-none focus:ring-2 focus:ring-zano-pink" required data-id="element-451" data-mp="1wbeen00av037" />
            <Button variant="primary" className="whitespace-nowrap" type="submit" data-id="element-452" data-mp="18mvb0xs73bhg">
              Subscribe
            </Button>
          </form>}
      </div>
    </section>;
};
import { Reveal } from './ui/Reveal';
import { FileImage, BarChart3, Sparkles, Send, CheckCircle2, ShieldCheck, Download, TrendingUp } from 'lucide-react';
export const CreatorAssetOS = () => <section className="relative py-24 bg-zano-charcoal text-white border-t border-gray-800 overflow-hidden" data-id="element-453" data-mp="3f9u9o9kjitea">
    {/* Ambient background accents to signal a distinct, forward-looking zone */}
    <div className="pointer-events-none absolute inset-0 opacity-[0.15]" data-id="element-454" data-mp="3p1gu8wirq4tp">
      <div className="absolute -top-24 left-1/4 w-96 h-96 rounded-full bg-zano-pink blur-3xl" data-id="element-455" data-mp="6usor5jt3fni" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-indigo-500 blur-3xl" data-id="element-456" data-mp="1y26cbkj47yx" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-457" data-mp="28o9w0840yehq">
      <Reveal data-id="element-458" data-mp="23p6yr9uadckb">
        <div className="max-w-3xl mx-auto text-center mb-14" data-id="element-459" data-mp="23pfc12ubmjw1">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-zano-pink/15 text-zano-pink text-xs font-bold uppercase tracking-wider border border-zano-pink/40 mb-6" data-id="element-460" data-mp="j6mofqc0f9bc">
            <span className="relative flex h-2 w-2" data-id="element-461" data-mp="9gjkiv3coay8">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-zano-pink opacity-75" data-id="element-462" data-mp="9fryaavn7pkm" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-zano-pink" data-id="element-463" data-mp="edthcvt2jow3" />
            </span>
            Coming Soon
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-464" data-mp="5fhmghl664xu">
            The future of Zano:{' '}
            <span className="text-zano-pink" data-id="element-465" data-mp="3mnlgamlp020d">
              the OS for represented talent
            </span>
          </h2>
          <p className="text-lg text-gray-300" data-id="element-466" data-mp="3rmxy2sxpiiw3">
            This is where we're headed. We're building the operating system for
            the representation space — where talent agencies, marketing
            agencies, and brands come together to build world-class campaigns.
            One platform for agency-to-agency and agency-to-brand collaboration
            across the elite market. Here's a sneak peek at what's in the works.
          </p>
        </div>
      </Reveal>

      <div className="space-y-8" data-id="element-467" data-mp="1eeoob0idcnnm">
        {/* Discovery Layer */}
        <Reveal delay={0.1} data-id="element-468" data-mp="1aduzm4x3r4to">
          <div className="relative bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-469" data-mp="1aemvzhyix6l0">
            <span className="absolute top-4 right-4 z-10 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-zano-charcoal text-white text-[10px] font-semibold uppercase tracking-wide shadow-sm" data-id="element-470" data-mp="2732mphdddlzp">
              <Sparkles size={11} className="text-zano-pink" data-id="element-471" data-mp="1xczv9llwcg3h" /> In development
            </span>
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50/50 to-transparent" data-id="element-472" data-mp="1tbnymw4luuls">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-473" data-mp="2pvex8re6ftkx">
                1. Enhancing our Discovery Layer
              </h3>
              <p className="text-gray-600 max-w-2xl" data-id="element-474" data-mp="2l227uf1obir4">
                Finding the right talent and verifying representation is about
                to get even easier.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-100" data-id="element-475" data-mp="glxcnie1vx2e">
              {/* Live Chat */}
              <div className="p-6 flex flex-col" data-id="element-476" data-mp="lm36943vrtn4">
                <div className="flex-1" data-id="element-477" data-mp="linv2cdbv4qz">
                  <div className="w-10 h-10 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-4" data-id="element-478" data-mp="qj22bs73uany">
                    <MessageSquare size={20} data-id="element-479" data-mp="vhn4hx5x34f1" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-480" data-mp="109oc35s546yq">Live Chat</h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-481" data-mp="14b9wrdax1pjh">
                    Brands, marketing agencies, and talent agencies can speak
                    directly to each other on Zano, keeping communication
                    centralized.
                  </p>
                </div>
                {/* Mockup */}
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-3 h-40 flex flex-col justify-end relative overflow-hidden" data-id="element-482" data-mp="p58wdo5084w2">
                  <div className="space-y-3 w-full" data-id="element-483" data-mp="k9tkh1qk4j2a">
                    <div className="flex gap-2 items-end" data-id="element-484" data-mp="y673ifaqosiv">
                      <div className="w-6 h-6 rounded-full bg-gray-300 shrink-0" data-id="element-485" data-mp="u5n4f66lveu3"></div>
                      <div className="bg-white border border-gray-200 rounded-2xl rounded-bl-sm px-3 py-2 text-[10px] text-gray-600 shadow-sm" data-id="element-486" data-mp="u3sl1wazfus4">
                        Are they available for a Q3 campaign?
                      </div>
                    </div>
                    <div className="flex gap-2 items-end justify-end" data-id="element-487" data-mp="f95umje2e89n">
                      <div className="bg-zano-pink text-white rounded-2xl rounded-br-sm px-3 py-2 text-[10px] shadow-sm" data-id="element-488" data-mp="ah4egmdrzxec">
                        Yes, let's discuss rates!
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 bg-white border border-gray-200 rounded-full flex items-center px-3 py-1.5 shadow-sm" data-id="element-489" data-mp="3evm12ji7a1he">
                    <span className="text-[10px] text-gray-400 flex-1" data-id="element-490" data-mp="39inmygekiozm">
                      Type a message...
                    </span>
                    <Send size={12} className="text-zano-pink" data-id="element-491" data-mp="2uusr4r59k4ib" />
                  </div>
                </div>
              </div>

              {/* Influencer Verification */}
              <div className="p-6 flex flex-col" data-id="element-492" data-mp="3nhvohfy7e96z">
                <div className="flex-1" data-id="element-493" data-mp="3nj6qba8396vg">
                  <div className="w-10 h-10 bg-emerald-50 text-emerald-600 rounded-lg flex items-center justify-center mb-4" data-id="element-494" data-mp="3sh88zu1lr46e">
                    <CheckCircle size={20} data-id="element-495" data-mp="3dj7jpiv8bql8" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-496" data-mp="3ij28ngvg263n">
                    Influencer Verification
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-497" data-mp="2240yu4rbk009">
                    Talent agencies can ask influencers to opt in, displaying a
                    checkmark that confirms their talent manager as their
                    agent—making Zano the source of truth.
                  </p>
                </div>
                {/* Mockup */}
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 h-40 flex items-center justify-center relative overflow-hidden" data-id="element-498" data-mp="2luhx88x4o5vp">
                  <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm w-full max-w-[200px] text-center relative" data-id="element-499" data-mp="2qs05ry78gj36">
                    <div className="absolute -top-3 -right-3 bg-emerald-100 text-emerald-600 rounded-full p-1.5 shadow-sm border border-emerald-200" data-id="element-500" data-mp="2cvwgmjb7v0xk">
                      <ShieldCheck size={16} data-id="element-501" data-mp="22wfe2ar9h35t" />
                    </div>
                    <div className="w-12 h-12 bg-gray-200 rounded-full mx-auto mb-2 relative" data-id="element-502" data-mp="27txdnaje2615">
                      <div className="absolute bottom-0 right-0 bg-blue-500 text-white rounded-full p-0.5 border-2 border-white" data-id="element-503" data-mp="1492ekqc45rm">
                        <CheckCircle2 size={10} data-id="element-504" data-mp="62105vdnum3q" />
                      </div>
                    </div>
                    <div className="font-bold text-gray-900 text-xs" data-id="element-505" data-mp="1qlwg7k8y076g">
                      Elena Rodriguez
                    </div>
                    <div className="text-[10px] text-gray-500 mt-1" data-id="element-506" data-mp="1ljysodtieq7p">
                      Represented by UTA
                    </div>
                    <div className="mt-2 inline-flex items-center gap-1 bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded-full text-[9px] font-medium border border-emerald-200" data-id="element-507" data-mp="1vjpk26mrwp3k">
                      <CheckCircle2 size={10} data-id="element-508" data-mp="25a10utrk2srv" /> Verified Representation
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Search & Discovery */}
              <div className="p-6 flex flex-col" data-id="element-509" data-mp="2eayvilg3tnxs">
                <div className="flex-1" data-id="element-510" data-mp="2eb8omhwg4b7p">
                  <div className="w-10 h-10 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center mb-4" data-id="element-511" data-mp="ovrfm8im1k59">
                    <Search size={20} data-id="element-512" data-mp="jxhi3r9ey7gh" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-513" data-mp="jz0z5k2w8mjb">
                    AI Search & Discovery
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-514" data-mp="2oxijm7t2zu33">
                    Automatically tagging content and helping you find those
                    highly specific, niche creators that brands need for
                    targeted campaigns.
                  </p>
                </div>
                {/* Mockup */}
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 h-40 flex flex-col justify-center relative overflow-hidden" data-id="element-515" data-mp="32xa14iit3slu">
                  <div className="bg-white border-2 border-purple-200 rounded-lg p-2 flex items-center gap-2 shadow-sm mb-3" data-id="element-516" data-mp="3cnv0i86b115t">
                    <Sparkles size={14} className="text-purple-500 shrink-0" data-id="element-517" data-mp="3go54jfajdhi1" />
                    <span className="text-[10px] text-gray-800 font-medium" data-id="element-518" data-mp="3lot62uwe5gqi">
                      "NYC foodies with high engagement"
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-1.5" data-id="element-519" data-mp="4lx374tcacca">
                    <span className="bg-purple-50 text-purple-700 border border-purple-100 px-2 py-1 rounded text-[9px] font-medium" data-id="element-520" data-mp="4nhw6q009n81">
                      #nyceats
                    </span>
                    <span className="bg-purple-50 text-purple-700 border border-purple-100 px-2 py-1 rounded text-[9px] font-medium" data-id="element-521" data-mp="3qtwq4e10ugfl">
                      Engagement &gt; 5%
                    </span>
                    <span className="bg-purple-50 text-purple-700 border border-purple-100 px-2 py-1 rounded text-[9px] font-medium" data-id="element-522" data-mp="nbwnlee8j39d">
                      Location: NYC
                    </span>
                  </div>
                  <div className="mt-3 flex items-center gap-2" data-id="element-523" data-mp="dkih2mnv936q">
                    <div className="flex -space-x-2" data-id="element-524" data-mp="9k8bvc7wegsx">
                      <div className="w-6 h-6 rounded-full bg-gray-300 border-2 border-white" data-id="element-525" data-mp="162w6bxv4zgu7"></div>
                      <div className="w-6 h-6 rounded-full bg-gray-400 border-2 border-white" data-id="element-526" data-mp="11c7g0lv70pwn"></div>
                      <div className="w-6 h-6 rounded-full bg-gray-500 border-2 border-white" data-id="element-527" data-mp="lu65sswycw1a"></div>
                    </div>
                    <span className="text-[10px] text-gray-500 font-medium" data-id="element-528" data-mp="qtiz9wibx1cu">
                      +24 matches found
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-529" data-mp="gwwhjglauqf1">
          {/* Campaign Management */}
          <Reveal delay={0.2} className="h-full" data-id="element-530" data-mp="14n092pl7qzpo">
            <div className="relative bg-white rounded-2xl border border-gray-200 shadow-sm p-8 h-full flex flex-col hover:border-zano-pink/30 hover:shadow-float transition-all duration-300" data-id="element-531" data-mp="19ipbd0omaupo">
              <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-zano-charcoal text-white text-[10px] font-semibold uppercase tracking-wide shadow-sm" data-id="element-532" data-mp="zsvzrzoh6flf">
                <Sparkles size={11} className="text-zano-pink" data-id="element-533" data-mp="1sb9zk4tdgbn5" /> In development
              </span>
              <div className="flex-1" data-id="element-534" data-mp="3czlweadgefwc">
                <div className="w-12 h-12 bg-orange-50 text-orange-600 rounded-xl flex items-center justify-center mb-6" data-id="element-535" data-mp="3cykily51zfax">
                  <FolderKanban size={24} data-id="element-536" data-mp="3mq736l3a6qqc" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-537" data-mp="3mpovmsb64q34">
                  2. Campaign Management
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-538" data-mp="2u1t0hs18z68g">
                  Handle the entire lifecycle of a deal in one place. Manage
                  briefs, set up negotiations, review drafts, handle approvals,
                  and track final deliverables without leaving the platform.
                </p>
              </div>
              {/* Mockup */}
              <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 relative overflow-hidden" data-id="element-539" data-mp="2z2yzg7li3pqf">
                <div className="flex justify-between items-center mb-3" data-id="element-540" data-mp="jbkweaunkoil">
                  <span className="text-[10px] font-bold text-gray-700 uppercase" data-id="element-541" data-mp="eadma551fd8r">
                    Summer Launch
                  </span>
                  <span className="text-[9px] bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full font-medium" data-id="element-542" data-mp="qcocph7dxl5v">
                    In Progress
                  </span>
                </div>
                <div className="space-y-2" data-id="element-543" data-mp="10b42nguoeods">
                  <div className="flex items-center gap-2" data-id="element-544" data-mp="109t35t89k2sh">
                    <CheckCircle2 size={14} className="text-emerald-500" data-id="element-545" data-mp="2nlzcljsaeh6" />
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-546" data-mp="2lixn499qwwm">
                      <div className="w-full h-full bg-emerald-500" data-id="element-547" data-mp="7kce95jur410"></div>
                    </div>
                    <span className="text-[9px] text-gray-500 w-12" data-id="element-548" data-mp="cjgn1v2v6zqt">Brief</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-549" data-mp="hecmhgafkpdy">
                    <CheckCircle2 size={14} className="text-emerald-500" data-id="element-550" data-mp="3g1gwzfrzdf72" />
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-551" data-mp="3l0tgbqjn844w">
                      <div className="w-full h-full bg-emerald-500" data-id="element-552" data-mp="226qoh7ak4xes"></div>
                    </div>
                    <span className="text-[9px] text-gray-500 w-12" data-id="element-553" data-mp="1y43sqvarmscb">
                      Negotiate
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-554" data-mp="1t3pjj9xfhccp">
                    <div className="w-3.5 h-3.5 rounded-full border-2 border-orange-400" data-id="element-555" data-mp="1o78t292ralwg"></div>
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-556" data-mp="1j7mi66aehhqt">
                      <div className="w-1/2 h-full bg-orange-400" data-id="element-557" data-mp="1eg4f9coth737"></div>
                    </div>
                    <span className="text-[9px] text-gray-900 font-medium w-12" data-id="element-558" data-mp="1aej724n89gzc">
                      Drafts
                    </span>
                  </div>
                  <div className="flex items-center gap-2 opacity-50" data-id="element-559" data-mp="15dv88wsrbvuk">
                    <div className="w-3.5 h-3.5 rounded-full border-2 border-gray-300" data-id="element-560" data-mp="10fjzkpe77rdx"></div>
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full" data-id="element-561" data-mp="vj393ojj10xo"></div>
                    <span className="text-[9px] text-gray-500 w-12" data-id="element-562" data-mp="2kbppzqbhrneg">
                      Approval
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Asset Management */}
          <Reveal delay={0.3} className="h-full" data-id="element-563" data-mp="2ag5v978nyura">
            <div className="relative bg-white rounded-2xl border border-gray-200 shadow-sm p-8 h-full flex flex-col hover:border-zano-pink/30 hover:shadow-float transition-all duration-300" data-id="element-564" data-mp="2fbtobxq9o822">
              <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-zano-charcoal text-white text-[10px] font-semibold uppercase tracking-wide shadow-sm" data-id="element-565" data-mp="25fqlsqri67el">
                <Sparkles size={11} className="text-zano-pink" data-id="element-566" data-mp="1wng8v1p83ntn" /> In development
              </span>
              <div className="flex-1" data-id="element-567" data-mp="1hq5r5alzllph">
                <div className="w-12 h-12 bg-pink-50 text-pink-600 rounded-xl flex items-center justify-center mb-6" data-id="element-568" data-mp="1hr7b64kzdijc">
                  <FileImage size={24} data-id="element-569" data-mp="132fi58qdau3h" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-570" data-mp="132xhie8btofm">
                  3. Asset & Licensing
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-571" data-mp="1d0lgjgcyti3l">
                  A dedicated layer for asset management and licensing rights.
                  Securely store final content, track usage rights, and manage
                  licensing agreements seamlessly.
                </p>
              </div>
              {/* Mockup */}
              <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 relative overflow-hidden" data-id="element-572" data-mp="1hywp7nrixmk8">
                <div className="grid grid-cols-2 gap-2 mb-2" data-id="element-573" data-mp="1vql0xpxv290o">
                  <div className="bg-gray-200 rounded-lg h-16 relative group overflow-hidden" data-id="element-574" data-mp="1qrhwo7ppg6tr">
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-575" data-mp="25or1a340r73f">
                      <Download size={14} className="text-white" data-id="element-576" data-mp="20s0lzi01gfj2" />
                    </div>
                    <div className="absolute bottom-1 left-1 bg-black/60 text-white text-[8px] px-1.5 rounded" data-id="element-577" data-mp="2d72tsr7395o0">
                      MP4
                    </div>
                  </div>
                  <div className="bg-gray-200 rounded-lg h-16 relative group overflow-hidden" data-id="element-578" data-mp="2m8aokzaebodc">
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-579" data-mp="2i9bobrzm0fs8">
                      <Download size={14} className="text-white" data-id="element-580" data-mp="1pjl9thu2fbvl" />
                    </div>
                    <div className="absolute bottom-1 left-1 bg-black/60 text-white text-[8px] px-1.5 rounded" data-id="element-581" data-mp="23aq0hufggtts">
                      JPG
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-2 flex items-center justify-between shadow-sm" data-id="element-582" data-mp="1au6yi46xikdk">
                  <div className="flex items-center gap-1.5" data-id="element-583" data-mp="16tmzev2sp6os">
                    <ShieldCheck size={14} className="text-emerald-500" data-id="element-584" data-mp="wowwalvnnwiz" />
                    <span className="text-[10px] font-medium text-gray-800" data-id="element-585" data-mp="wnlq6feqmcop">
                      Usage Rights
                    </span>
                  </div>
                  <span className="text-[9px] text-gray-500" data-id="element-586" data-mp="mrs86gi91qzj">
                    Expires in 6 mo
                  </span>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Reporting */}
          <Reveal delay={0.4} className="h-full" data-id="element-587" data-mp="1ffxwtecfc04n">
            <div className="relative bg-white rounded-2xl border border-gray-200 shadow-sm p-8 h-full flex flex-col hover:border-zano-pink/30 hover:shadow-float transition-all duration-300" data-id="element-588" data-mp="1kf0zis4xlu9g">
              <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-zano-charcoal text-white text-[10px] font-semibold uppercase tracking-wide shadow-sm" data-id="element-589" data-mp="1ag1q37ccdule">
                <Sparkles size={11} className="text-zano-pink" data-id="element-590" data-mp="3v6ai6nrr3gls" /> In development
              </span>
              <div className="flex-1" data-id="element-591" data-mp="21njz1voq11jz">
                <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center mb-6" data-id="element-592" data-mp="21naa8bfex0fv">
                  <BarChart3 size={24} data-id="element-593" data-mp="1wqtlbf0e2i1q" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-594" data-mp="1rwyvruy3r8uq">
                  4. Reporting & Analytics
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-595" data-mp="1mwtaqxmc8klm">
                  Analyze campaign performance with comprehensive reporting
                  tools. Measure ROI, track engagement metrics, and generate
                  beautiful reports.
                </p>
              </div>
              {/* Mockup */}
              <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 relative overflow-hidden" data-id="element-596" data-mp="140bafrtfbcdr">
                <div className="flex justify-between items-end mb-4" data-id="element-597" data-mp="33dp3xjm36aqz">
                  <div data-id="element-598" data-mp="33at6dwe5ho32">
                    <span className="text-[10px] text-gray-500 block mb-0.5" data-id="element-599" data-mp="2ydkntup3bi1a">
                      Total Reach
                    </span>
                    <span className="text-lg font-bold text-gray-900" data-id="element-600" data-mp="35x29pept4k10">
                      4.2M
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-emerald-500 bg-emerald-50 px-1.5 py-0.5 rounded text-[10px] font-medium" data-id="element-601" data-mp="3fnojgsauegbs">
                    <TrendingUp size={10} data-id="element-602" data-mp="3kl6j1s2yzj74" /> +12%
                  </div>
                </div>
                <div className="flex items-end gap-1.5 h-12 border-b border-gray-200 pb-1" data-id="element-603" data-mp="2mzsobs0x8wh4">
                  <div className="w-full bg-indigo-200 rounded-t-sm h-[40%]" data-id="element-604" data-mp="2rx10nbze26ag"></div>
                  <div className="w-full bg-indigo-300 rounded-t-sm h-[60%]" data-id="element-605" data-mp="2wwdwgm88mnp6"></div>
                  <div className="w-full bg-indigo-400 rounded-t-sm h-[45%]" data-id="element-606" data-mp="31w09ovo2g3xz"></div>
                  <div className="w-full bg-indigo-500 rounded-t-sm h-[80%]" data-id="element-607" data-mp="31tnh7okomb6o"></div>
                  <div className="w-full bg-indigo-600 rounded-t-sm h-[100%] relative" data-id="element-608" data-mp="c6es0mqeiwrb">
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[8px] px-1.5 py-0.5 rounded shadow-sm whitespace-nowrap" data-id="element-609" data-mp="h47wnbc23iph">
                      Peak
                    </div>
                  </div>
                </div>
                <div className="flex justify-between mt-1" data-id="element-610" data-mp="optmfdao9jph">
                  <span className="text-[8px] text-gray-400" data-id="element-611" data-mp="on7gfi3fjc9d">Mon</span>
                  <span className="text-[8px] text-gray-400" data-id="element-612" data-mp="jombx6h5a6f4">Fri</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>;